<template>
  <v-card-text class="pa-2 text-center">
    <template v-for="(letra, index) in 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'">
      <v-btn class="mr-1" icon small color="primary" :key="index" :outlined="letra_selecionada == letra" @click="selecionarLetra(letra)">{{ letra }}</v-btn>
    </template>
    <v-btn small rounded color="primary" :text="letra_selecionada != null" :outlined="letra_selecionada == null" @click="selecionarLetra(null)">Recentes</v-btn>
  </v-card-text>
</template>

<script>
export default {
  name: 'z-filtro-alfabetico',

  props: {
    value: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      letra_selecionada: null,
    };
  },

  methods: {
    selecionarLetra(letra) {
      this.letra_selecionada = letra;
      this.$emit('input', letra);
    },
  },

  watch: {
    value(newValue) {
      this.letra_selecionada = newValue;
    },
  },
};
</script>

<style lang="scss" scoped></style>
